export class ControlPlaneConfig {
    'staticPublicIps';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "staticPublicIps",
            "baseName": "staticPublicIps",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlPlaneConfig.attributeTypeMap;
    }
    constructor() {
    }
}
